import React, { useState } from "react";
import { useAuth } from "./AuthContext";

const S = {
  wrap:   { minHeight:"100vh", background:"#fff", display:"flex", flexDirection:"column", alignItems:"center", justifyContent:"center", padding:24, fontFamily:"Inter,sans-serif" },
  card:   { width:"100%", maxWidth:380, background:"#fafafa", borderRadius:16, border:"1px solid #ebebeb", padding:28 },
  logo:   { fontSize:26, fontWeight:700, color:"#111", letterSpacing:"-0.02em", marginBottom:4 },
  dot:    { display:"inline-block", width:7, height:7, borderRadius:"50%", background:"#81c784", marginLeft:5, verticalAlign:"middle" },
  sub:    { fontSize:12, color:"#bbb", marginBottom:28, fontFamily:"Inter,sans-serif" },
  label:  { display:"block", fontSize:11, color:"#888", fontWeight:600, letterSpacing:"0.04em", marginBottom:5 },
  input:  { width:"100%", padding:"10px 12px", borderRadius:8, border:"1px solid #e0e0e0", fontSize:13, fontFamily:"Inter,sans-serif", outline:"none", background:"#fff", marginBottom:14, boxSizing:"border-box" },
  btn:    { width:"100%", padding:"11px", borderRadius:10, border:"none", cursor:"pointer", background:"#1a1a1a", color:"#fff", fontFamily:"Inter,sans-serif", fontSize:13, fontWeight:600, marginTop:4 },
  err:    { background:"#fbe9e7", border:"1px solid #ff8a65", borderRadius:8, padding:"9px 12px", fontSize:12, color:"#bf360c", marginBottom:14, fontFamily:"Inter,sans-serif" },
  toggle: { textAlign:"center", marginTop:18, fontSize:12, color:"#aaa", cursor:"pointer", fontFamily:"Inter,sans-serif" },
  link:   { color:"#1a1a1a", fontWeight:600, textDecoration:"underline", cursor:"pointer" },
};

export default function LoginScreen() {
  const { login, register } = useAuth();
  const [mode,   setMode]   = useState("login");  // "login" | "register"
  const [form,   setForm]   = useState({ username:"", email:"", password:"", display_name:"" });
  const [err,    setErr]    = useState("");
  const [busy,   setBusy]   = useState(false);

  function set(k, v) { setForm(f => ({ ...f, [k]: v })); }

  async function submit(e) {
    e.preventDefault();
    setBusy(true); setErr("");
    try {
      if (mode === "login") {
        await login(form.username, form.password);
      } else {
        await register({ username: form.username, email: form.email, password: form.password, display_name: form.display_name });
      }
    } catch (ex) {
      setErr(ex.message);
    } finally {
      setBusy(false);
    }
  }

  return (
    <div style={S.wrap}>
      <div style={S.card}>
        <div style={S.logo}>Chordsn<span style={S.dot}/></div>
        <div style={S.sub}>{mode === "login" ? "Willkommen zurück" : "Neues Konto erstellen"}</div>

        {err && <div style={S.err}>{err}</div>}

        <form onSubmit={submit}>
          <label style={S.label}>BENUTZERNAME</label>
          <input style={S.input} value={form.username} autoComplete="username"
            onChange={e => set("username", e.target.value)} placeholder="benutzername" required />

          {mode === "register" && (
            <>
              <label style={S.label}>ANZEIGENAME (optional)</label>
              <input style={S.input} value={form.display_name}
                onChange={e => set("display_name", e.target.value)} placeholder="Dein Name" />
              <label style={S.label}>E-MAIL</label>
              <input style={S.input} type="email" value={form.email} autoComplete="email"
                onChange={e => set("email", e.target.value)} placeholder="name@example.com" required />
            </>
          )}

          <label style={S.label}>PASSWORT</label>
          <input style={S.input} type="password" value={form.password} autoComplete={mode==="login"?"current-password":"new-password"}
            onChange={e => set("password", e.target.value)} placeholder="••••••••" required />

          <button style={{ ...S.btn, opacity: busy ? 0.6 : 1 }} disabled={busy}>
            {busy ? "…" : mode === "login" ? "Anmelden" : "Registrieren"}
          </button>
        </form>

        <div style={S.toggle}>
          {mode === "login"
            ? <>Noch kein Konto? <span style={S.link} onClick={() => { setMode("register"); setErr(""); }}>Registrieren</span></>
            : <>Bereits registriert? <span style={S.link} onClick={() => { setMode("login"); setErr(""); }}>Anmelden</span></>
          }
        </div>
      </div>
    </div>
  );
}
